import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-svg-icon',
  templateUrl: './svg-icon.component.html',
  styleUrls: ['./svg-icon.component.less']
})
export class SvgComponent {
  @Input() iconId: string;

  constructor() {}

  // get absUrl() {
  //   return window.location.href;
  // }

}
